import React, {useContext, useState} from 'react';
import notes from "../../services/api/notes";
import moment from "moment/moment";
import MenuIcon from '../../images/menu.svg';
import {GlobalContext} from "../../context/GlobalState";

const Video = ({selectVideo, videoId, videos}) => {
  const {openMoveModal} = useContext(GlobalContext);
  const video = videos[videoId];
  const firstNote = video.notes[0];
  const videoTitle = firstNote.videoTitle.length > 26 ? firstNote.videoTitle.slice(0, 26) + '...' : firstNote.videoTitle;
  const [shareLink, setShareLink] = useState('');

  const deleteNotes = async ids => {
    try {
      await notes.delete(ids);
      // TODO: Notify better that this was successful (message queue would be cool like Toast)
      window.location.reload();
    } catch (e) {
      // TODO: Show error
    }
  };

  const promptDelete = async () => {
    const shouldDelete = window.confirm('Are you sure you want to delete all notes for this video?');

    if (shouldDelete) {
      let ids = video.notes.map(note => note.id);
      await deleteNotes(ids);
    }
  };

  const getShareUrl = async () => {
    if (!shareLink) {
      // If shareUrl exists and is unique for all notes, display
      // Otherwise, call api to generate new shareUrl
      const shareUrl = [...new Set(video.notes.map(note => note.shareUrl))];
      if (shareUrl.length === 1 && shareUrl[0]) {
        setShareLink(shareUrl[0]);
      } else {
        const noteIds = video.notes.map(note => note.id);
        const {data} = await notes.genShareUrl(noteIds);
        setShareLink(data);
      }
    }
  };

  return (
    <div className='row video-row' key={`video-${videoId}`} onClick={() => {
      selectVideo(videoId);
    }}>
      <div className='video-title'>
        <div className="thumbnail-container">
          <img src={firstNote.screenshot ? firstNote.screenshot : `https://i1.ytimg.com/vi/${videoId}/mqdefault.jpg`} alt="thumbnail"/>
        </div>
        <p>{videoTitle}</p>
      </div>
      <div className='note-count'>
        <p>{`${video.count} ${video.count === 1 ? 'note' : 'notes'}`}</p>
      </div>
      <div className='modified'>
        <p>{moment(video.modified).format('MM/DD/YYYY h:mm a')}</p>
      </div>
      <div className='members'>
        <p>{`${video.members} member${video.members !== 1 ? 's' : ''}`}</p>
      </div>
      <div className="menu-button-container">
        <div className="menu-button"
             onClick={e => {
               e.target.focus();
               e.stopPropagation();
               e.nativeEvent.stopImmediatePropagation()
             }}
             tabIndex="0"
        >
          <img src={MenuIcon} alt="menu" />
          <div className="menu">
            <ul>
              <li onClick={getShareUrl}>Share</li>
              <li onClick={promptDelete}>Delete</li>
              <li onClick={() => openMoveModal(videos[videoId], 'notes')}>Move</li>
            </ul>
          </div>
        </div>
      </div>
      {shareLink && (
        <div className='share-content' onClick={(e) => e.stopPropagation()}>
          <span>Share</span>
          <input type='text' value={`${window.location.host}/share/${shareLink}`} disabled/>
        </div>
      )}
    </div>
  )
};

export default Video;
